import { Helmet } from "react-helmet-async";

const SEO = ({
  title = "HeyPrompt",
  description = "Discover thousands of powerful AI prompts for ChatGPT, Gemini, Midjourney and more.",
  keywords = "AI prompts, ChatGPT prompts, Gemini prompts, Midjourney prompts, free AI prompts, prompt engineering, AI image prompts, prompt library, best AI prompts 2026, copy paste prompts, viral AI prompts, Instagram reel prompts, SEO prompts, marketing prompts, AI art prompts, prompt ideas, trending AI prompts",
  canonicalPath = "/"
}) => {
  const SITE_URL = "https://heyprompt.online";

  return (
    <Helmet>
      <title>{title} | HeyPrompt</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={`${SITE_URL}${canonicalPath}`} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${SITE_URL}${canonicalPath}`} />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;